import { useCallback, useState } from 'react';
import { Input, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';

import PageWrapper from '../../components/MainPageWrapper/PageWrapper';

import css from './MyCourses.module.css';
import {
  MY_COURSES_TABS,
  MY_COURSES_TAB_KEYS,
  MY_COURSES_TAB_PARAM,
  MyCoursesTabKey,
} from './MyCourses.const';
import MyCoursesCards from '../../components/MyCoursesCards/MyCoursesCards';

const MyCourses = () => {
  const { Title } = Typography;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const tabParam = searchParams.get(MY_COURSES_TAB_PARAM);
  const isValidTab = MY_COURSES_TABS.some((t) => t.key === tabParam);
  const activeTab: MyCoursesTabKey = isValidTab
    ? (tabParam as MyCoursesTabKey)
    : MY_COURSES_TAB_KEYS.ALL;

  const [searchValue, setSearchValue] = useState('');
  const [count, setCount] = useState<number | null>(null);
  const handleCount = useCallback((n: number) => setCount(n), []);

  const handleTabChange = (key: MyCoursesTabKey) => {
    const next = new URLSearchParams(search);
    if (key === MY_COURSES_TAB_KEYS.ALL) {
      next.delete(MY_COURSES_TAB_PARAM);
    } else {
      next.set(MY_COURSES_TAB_PARAM, key);
    }
    const qs = next.toString();
    history.replace(qs ? `${pathname}?${qs}` : pathname);
  };

  return (
    <PageWrapper>
      <div className={css.SelectWrapper}>
        <Title level={2} style={{ color: '#1677ff' }}>
          Мои курсы
        </Title>

        <div className={css.TabsRow}>
          <div className={css.Tabs}>
            {MY_COURSES_TABS.map((tab) => (
              <button
                key={tab.key}
                type='button'
                className={`${css.Tab} ${
                  activeTab === tab.key ? css.TabActive : ''
                }`}
                onClick={() => handleTabChange(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <Input
            className={css.Search}
            placeholder='Поиск по курсу или номеру договора'
            prefix={<SearchOutlined style={{ color: '#8c8c8c' }} />}
            allowClear
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        <Title level={5} className={css.SpecTitle}>
          Найдено: {count ?? '…'}
        </Title>

        <MyCoursesCards statusFilter={activeTab} search={searchValue} onCount={handleCount} />
      </div>
    </PageWrapper>
  );
};

export default MyCourses;
